export const getInitialLetterIndex = (text) => {
	const initialTagsRegex = new RegExp('^(\\s*<[^>]*>\\s*)+', 'i');
	const initialLetterRegex = new RegExp('[а-яА-ЯA-Za-z]', 'i');
	const tagsMatch = text.match(initialTagsRegex);

	let letterIndex = 0;

	if (tagsMatch) {
		const tags = tagsMatch[0];
		letterIndex += tags.length;
	}

	const initialLetter = text.charAt(letterIndex);
	if (!initialLetterRegex.test(initialLetter)) {
		letterIndex = -1;
	}

	return letterIndex;
};

export const stripBbcode = (text) => text.replace(/\[.*?]/gi, '');

export const stripTags = (text) => text.replace(/<.*?>/gi, '');

export const truncateText = (str, limit = 200, suffix = '...') => {
	let newStr;

	if (str.length > limit) {
		const lastWordIndex = str.substr(0, limit).lastIndexOf(' ');
		const cutTextByLastWord = str.substr(0, lastWordIndex);

		newStr = `${cutTextByLastWord}${suffix}`;
	} else {
		newStr = str;
	}

	return newStr;
};
